import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
/**
 * @license lucide-react v0.363.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import { forwardRef, createElement } from 'react';
import defaultAttributes from './defaultAttributes.js';
import { toKebabCase } from './shared/src/utils.js';
var createLucideIcon = function createLucideIcon(iconName, iconNode) {
  var Component = forwardRef(function (_ref, ref) {
    var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$strokeWidth = _ref.strokeWidth,
      strokeWidth = _ref$strokeWidth === void 0 ? 2 : _ref$strokeWidth,
      absoluteStrokeWidth = _ref.absoluteStrokeWidth,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["color", "size", "strokeWidth", "absoluteStrokeWidth", "className", "children"]);
    return createElement("svg", _objectSpread({
      ref: ref
    }, defaultAttributes, {
      width: size,
      height: size,
      stroke: color,
      strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
      className: ["lucide", "lucide-".concat(toKebabCase(iconName)), className].join(" ")
    }, rest), [].concat(_toConsumableArray(iconNode.map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        tag = _ref3[0],
        attrs = _ref3[1];
      return createElement(tag, attrs);
    })), _toConsumableArray(Array.isArray(children) ? children : [children])));
  });
  Component.displayName = "".concat(iconName);
  return Component;
};
export { createLucideIcon as default };